import React, { useState } from 'react'
import { Container, Row, Col, Card, CardBody, CardHeader, CardFooter, Form, FormGroup, Label, Input, Button } from 'reactstrap'
import { Breadcrumbs, H4 } from '../../AbstractElements'
import { useNavigate } from 'react-router-dom'
import { updateUser } from '../../lib/auth'
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents'

const ChangePassword = () => {
	const navigate = useNavigate()
	const [eye, setEye] = useState(true)
	const [eye2, setEye2] = useState(true)
	const [passwordInput, setPasswordInput] = useState('')
	const [passwordInput2, setPasswordInput2] = useState('')
	const [validationError, setValidationError] = useState('')
	const [loading, setLoading] = useState(false)
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	const onEyeClick = () => {
		setEye(!eye)
	}

	const onEyeClick2 = () => {
		setEye2(!eye2)
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setValidationError('')
		setLoading(true)

		try {
			if (passwordInput.length < 6) {
				setValidationError('Password must be at least 6 characters.')
				setLoading(false)
				return
			}

			if (passwordInput !== passwordInput2) {
				setValidationError('Passwords do not match.')
				setLoading(false)
				return
			}

			const { error } = await updateUser(passwordInput)

			if (error) {
				setValidationError(error.message || 'Failed to update password')
			} else {
				showToastMessage('Password updated successfully!')
				setTimeout(() => navigate(-1), 2000)
			}
		} catch (error) {
			setValidationError('An unexpected error occurred')
			console.error('Error updating password:', error)
		} finally {
			setLoading(false)
		}
	}

	return (
		<>
		<div className="position-relative">
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
			<Breadcrumbs mainTitle="Change Password" parent="Profile" title="Change Password" />
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Form onSubmit={handleSubmit}>
							<Card className="shadow">
								<CardHeader className="bg-warning text-dark">
									<H4 attrH4={{ className: 'card-title mb-2 text-dark' }}>
										<i className="fa fa-key me-2"></i>
										Change Password
									</H4>
									<p className="mb-0 text-dark-50">Enter your new password below to update your account security.</p>
								</CardHeader>
								<CardBody className="p-4">
									<div className="row">
										<Col md="6">
											<FormGroup className="mb-4">
												<Label className="form-control-label fw-bold mb-2">
													New Password
													<span className="text-danger ms-1">*</span>
												</Label>
												<div className="input-group">
													<Input
														className="form-control border-radius-10"
														name="passwordInput"
														value={passwordInput}
														onChange={(e) => setPasswordInput(e.target.value)}
														placeholder="Enter new password"
														type={eye ? 'password' : 'text'}
														required
														style={{
															border: '1px solid #e9ecef',
															boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
															height: '50px',
															padding: '12px 15px'
														}}
													/>
													<Button
														className="btn btn-outline-secondary border-radius-10"
														type="button"
														onClick={onEyeClick}
														style={{ borderLeft: 'none' }}
													>
														{eye ? <i className="fa fa-eye"></i> : <i className="fa fa-eye-slash"></i>}
													</Button>
												</div>
												<small className="text-muted mt-1">
													<i className="fa fa-info-circle me-1"></i>
													Password must be at least 6 characters long
												</small>
											</FormGroup>
										</Col>
										<Col md="6">
											<FormGroup className="mb-4">
												<Label className="form-control-label fw-bold mb-2">
													Confirm Password
													<span className="text-danger ms-1">*</span>
												</Label>
												<div className="input-group">
													<Input
														className="form-control border-radius-10"
														name="passwordInput2"
														value={passwordInput2}
														onChange={(e) => setPasswordInput2(e.target.value)}
														placeholder="Confirm new password"
														type={eye2 ? 'password' : 'text'}
														required
														style={{
															border: '1px solid #e9ecef',
															boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
															height: '50px',
															padding: '12px 15px'
														}}
													/>
													<Button
														className="btn btn-outline-secondary border-radius-10"
														type="button"
														onClick={onEyeClick2}
														style={{ borderLeft: 'none' }}
													>
														{eye2 ? <i className="fa fa-eye"></i> : <i className="fa fa-eye-slash"></i>}
													</Button>
												</div>
												<small className="text-muted mt-1">
													<i className="fa fa-info-circle me-1"></i>
													Re-enter your new password to confirm
												</small>
											</FormGroup>
										</Col>
									</div>

									{validationError && (
										<div className="alert alert-danger border-radius-10 mt-4" role="alert">
											<i className="fa fa-exclamation-triangle me-2"></i>
											<strong>Error:</strong> {validationError}
										</div>
									)}

									<div className="password-requirements mt-4 p-3 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
										<h6 className="text-primary mb-3">
											<i className="fa fa-shield-alt me-2"></i>
											Password Requirements
										</h6>
										<ul className="list-unstyled mb-0">
											<li className="mb-2">
												<i className="fa fa-check-circle text-success me-2"></i>
												At least 6 characters long
											</li>
											<li className="mb-2">
												<i className="fa fa-check-circle text-success me-2"></i>
												Use a combination of letters, numbers, and symbols for better security
											</li>
										</ul>
									</div>
								</CardBody>
								<CardFooter className="bg-light border-top">
									<div className="d-flex justify-content-end gap-3">
										<Button color="secondary" className="px-4 py-2" onClick={() => navigate(-1)} style={{ minWidth: '100px' }}>
											<i className="fa fa-times me-2"></i>
											Cancel
										</Button>
										<Button color="warning" type="submit" disabled={loading} className="px-4 py-2 text-white" style={{ minWidth: '140px' }}>
											{loading ? (
												<>
													<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
													Updating...
												</>
											) : (
												<>
													<i className="fa fa-key me-2"></i>
													Update Password
												</>
											)}
										</Button>
									</div>
								</CardFooter>
							</Card>
						</Form>
					</Col>
				</Row>
			</Container>
		</div>
		</>
	)
}

export { ChangePassword }
